import React from 'react';
import './PastEventCard.css';

const PastEventCard = ({ image, title, date, subtitle, description, readMoreUrl }) => {
    return (
        <article className="past-event-card">
            <div className="past-card-image">
                <img src={image} alt={title} />
            </div>

            <div className="past-card-content">
                <h3 className="past-card-title">{title}</h3>

                <div className="past-card-meta">
                    {subtitle && <div className="past-card-subtitle">{subtitle}</div>}
                    <div className="past-card-date">{date}</div>
                </div>

                <p className="past-card-description">{description}</p>

                {readMoreUrl ? (
                    <a className="past-card-readmore" href={readMoreUrl}>
                        Read more <span className="past-card-arrow">→</span>
                    </a>
                ) : (
                    <div className="past-card-readmore" aria-hidden="true">Read more <span className="past-card-arrow">→</span></div>
                )}
            </div>
        </article>
    );
};

export default PastEventCard;
